export default __webpack_public_path__ + "static/media/2-Cloudxier-PTSTP.4fce5b2b.png";